import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHeroTransparent = onHome && !scrolled;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isHeroTransparent
          ? 'bg-transparent'
          : 'bg-white/95 backdrop-blur-md border-b border-foreground-200/30'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-xl font-semibold whitespace-nowrap transition-colors cursor-pointer ${
              isHeroTransparent ? 'text-white' : 'text-foreground-900'
            }`}
          >
            Kakobuy<span className="font-light">Spreadsheet</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:opacity-80 cursor-pointer ${
                isHeroTransparent ? 'text-white/90' : 'text-foreground-700'
              }`}
            >
              Home
            </Link>
            <a
              href={onHome ? '#guides' : '/#guides'}
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:opacity-80 cursor-pointer ${
                isHeroTransparent ? 'text-white/90' : 'text-foreground-700'
              }`}
            >
              Shopping Guide
            </a>
            <a
              href={onHome ? '#categories' : '/#categories'}
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:opacity-80 cursor-pointer ${
                isHeroTransparent ? 'text-white/90' : 'text-foreground-700'
              }`}
            >
              Categories
            </a>
            <a
              href={onHome ? '#safety' : '/#safety'}
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:opacity-80 cursor-pointer ${
                isHeroTransparent ? 'text-white/90' : 'text-foreground-700'
              }`}
            >
              Safety
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full border transition-all duration-200 cursor-pointer ${
                isHeroTransparent
                  ? 'bg-white/20 border-white/30 text-white hover:bg-white/30'
                  : 'border-foreground-300 text-foreground-700 hover:bg-foreground-900 hover:text-white hover:border-foreground-900'
              }`}
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-5 py-2 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isHeroTransparent ? 'text-white' : 'text-foreground-900'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-foreground-200/30">
          <div className="px-6 py-4 flex flex-col gap-3">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap"
            >
              Home
            </Link>
            <a
              href={onHome ? '#guides' : '/#guides'}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap"
            >
              Shopping Guide
            </a>
            <a
              href={onHome ? '#categories' : '/#categories'}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap"
            >
              Categories
            </a>
            <a
              href={onHome ? '#safety' : '/#safety'}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap"
            >
              Safety
            </a>
            <div className="flex flex-col gap-2 pt-3 border-t border-foreground-200/30">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="whitespace-nowrap px-4 py-2.5 text-sm font-medium rounded-full text-center border border-primary-500 text-primary-600 cursor-pointer"
              >
                Kakobuy Spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="whitespace-nowrap px-4 py-2.5 text-sm font-semibold rounded-full text-center bg-primary-500 text-white cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}